/* =====================================================================
   Dinî bayramlar (Ramazan + Kurban) — Diyanet'in açıkladığı resmî tatil
   günleri (2018–2032). "kesinlesme.html" verisinden birebir taşındı.

   Millî tatillerden ayrı tutulur: bunlar yıllık kayan açık tarih listesidir,
   kapsam dışı yıllar kullanıcı tarafından eklenebilir (ekBayramlar). Bu yüzden
   kapsam-eksiği uyarısı ve kullanıcı yönetimi yalnızca bu modüldedir.

   SAFLIK: HTML'deki modül-global mutable `DINI_SET` + yan etkili
   `diniSetGuncelle()` kaldırıldı. Yerine saf `diniSetKur(ekBayramlar)`
   her hesapta etkin kümeyi yeniden kurar (taban ∪ kullanıcı eklemeleri).
   ===================================================================== */

import { addDays, parseIso } from './isGunuHesap';

export const DINI_BAYRAM_GUNLERI = [
  '2018-06-15', '2018-06-16', '2018-06-17', '2018-08-21', '2018-08-22', '2018-08-23', '2018-08-24',
  '2019-06-04', '2019-06-05', '2019-06-06', '2019-08-11', '2019-08-12', '2019-08-13', '2019-08-14',
  '2020-05-24', '2020-05-25', '2020-05-26', '2020-07-31', '2020-08-01', '2020-08-02', '2020-08-03',
  '2021-05-13', '2021-05-14', '2021-05-15', '2021-07-20', '2021-07-21', '2021-07-22', '2021-07-23',
  '2022-05-02', '2022-05-03', '2022-05-04', '2022-07-09', '2022-07-10', '2022-07-11', '2022-07-12',
  '2023-04-21', '2023-04-22', '2023-04-23', '2023-06-28', '2023-06-29', '2023-06-30', '2023-07-01',
  '2024-04-10', '2024-04-11', '2024-04-12', '2024-06-16', '2024-06-17', '2024-06-18', '2024-06-19',
  '2025-03-30', '2025-03-31', '2025-04-01', '2025-06-06', '2025-06-07', '2025-06-08', '2025-06-09',
  '2026-03-20', '2026-03-21', '2026-03-22', '2026-05-27', '2026-05-28', '2026-05-29', '2026-05-30',
  '2027-03-09', '2027-03-10', '2027-03-11', '2027-05-16', '2027-05-17', '2027-05-18', '2027-05-19',
  '2028-02-26', '2028-02-27', '2028-02-28', '2028-05-05', '2028-05-06', '2028-05-07', '2028-05-08',
  '2029-02-14', '2029-02-15', '2029-02-16', '2029-04-24', '2029-04-25', '2029-04-26', '2029-04-27',
  '2030-02-04', '2030-02-05', '2030-02-06', '2030-04-13', '2030-04-14', '2030-04-15', '2030-04-16',
  '2031-01-24', '2031-01-25', '2031-01-26', '2031-04-02', '2031-04-03', '2031-04-04', '2031-04-05',
  '2032-01-14', '2032-01-15', '2032-01-16', '2032-03-22', '2032-03-23', '2032-03-24', '2032-03-25',
];

const DINI_YILLAR = DINI_BAYRAM_GUNLERI.map((s) => Number(s.slice(0, 4)));
export const DINI_KAPSAM = { min: Math.min(...DINI_YILLAR), max: Math.max(...DINI_YILLAR) };

export function bayramTipAdi(tip) {
  return tip === 'kurban' ? 'Kurban Bayramı' : 'Ramazan Bayramı';
}

/** Bir bayramın tüm tatil günleri (ilk günden ardışık): Ramazan 3, Kurban 4 gün. */
export function bayramGunleri(tip, ilkGun) {
  const adet = tip === 'kurban' ? 4 : 3;
  const gunler = [];
  for (let i = 0; i < adet; i++) gunler.push(addDays(ilkGun, i));
  return gunler;
}

/** Kayıtlı/girilen ek bayram listesini doğrular: geçersiz tarih, kapsam içi yıl ve tekrarları eler. */
export function ekBayramlariTemizle(arr) {
  if (!Array.isArray(arr)) return [];
  const out = [];
  for (const b of arr) {
    if (!b || (b.tip !== 'ramazan' && b.tip !== 'kurban')) continue;
    const d = parseIso(b.ilkGun);
    if (!d) continue;
    const yil = d.getFullYear();
    if (yil >= DINI_KAPSAM.min && yil <= DINI_KAPSAM.max) continue; // sistemdeki yıllarla çelişmesin
    if (out.some((x) => x.tip === b.tip && parseIso(x.ilkGun).getFullYear() === yil)) continue;
    out.push({ tip: b.tip, ilkGun: b.ilkGun });
  }
  out.sort((a, b) => (a.ilkGun < b.ilkGun ? -1 : 1));
  return out;
}

/**
 * Etkin dinî bayram kümesi: temel veri ∪ kullanıcı eklemeleri. SAF —
 * paylaşılan hiçbir state'i değiştirmez, her çağrıda yeni Set döndürür.
 */
export function diniSetKur(ekBayramlar = []) {
  const s = new Set(DINI_BAYRAM_GUNLERI);
  for (const b of ekBayramlar) {
    for (const g of bayramGunleri(b.tip, b.ilkGun)) s.add(g);
  }
  return s;
}
